<div class="dashboard-layout" [class.sidebar-collapsed]="sidebarCollapsed">
  <!-- Mobile Sidebar Overlay -->
  <p-drawer
    [(visible)]="sidebarVisible"
    position="left"
    [modal]="true"
    styleClass="mobile-sidebar"
    (onHide)="onSidebarHide()"
    *ngIf="isMobile">
    <ng-template pTemplate="header">
      <div class="mobile-drawer-header">
        <div class="logo-circle">
          <i class="pi pi-briefcase"></i>
        </div>
        <div class="logo-text-wrapper">
          <span class="logo-text">{{ 'layout.sidebar.brandName' | transloco }}</span>
          <p class="logo-subtitle">{{ brandSubtitleKey | transloco }}</p>
        </div>
      </div>
    </ng-template>
    <app-dashboard-sidebar
      [isMobile]="true"
      [hideLogoSection]="true"
      (menuItemClick)="onSidebarHide()">
    </app-dashboard-sidebar>
  </p-drawer>

  <!-- Desktop Sidebar -->
  <aside class="sidebar-desktop" *ngIf="!isMobile">
    <app-dashboard-sidebar
      [isMobile]="false"
      [collapsed]="sidebarCollapsed"
      (collapseToggle)="toggleSidebarCollapse()">
    </app-dashboard-sidebar>
  </aside>

  <!-- Main Content Area -->
  <div class="main-content" [class.mobile]="isMobile">
    <!-- Top Bar -->
    <app-dashboard-topbar
      [isMobile]="isMobile"
      (sidebarToggle)="toggleSidebar()">
    </app-dashboard-topbar>

    <!-- Page Content -->
    <main class="page-content">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Globalne okno „Napisz do kandydata" (sterowane przez ContactCandidateService) -->
  <app-contact-candidate-dialog></app-contact-candidate-dialog>
</div>
